import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchBookByBarcode = createAsyncThunk(
  'books/fetchBookByBarcode',
  async (barcode, { rejectWithValue }) => {
    try {
      const response = await fetch(`http://localhost:8000/api/offers/${barcode}`);
      if (!response.ok) throw new Error('Failed to fetch book');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  bookOffer: localStorage.getItem('bookOffer')
    ? JSON.parse(localStorage.getItem('bookOffer'))
    : null,
};

const bookSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setBookOffer: (state, action) => {
      state.bookOffer = action.payload;
      localStorage.setItem('bookOffer', JSON.stringify(action.payload));
    },
    clearBookOffer: (state) => {
      state.bookOffer = null;
      localStorage.removeItem('bookOffer');
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchBookByBarcode.pending, (state) => {
  //       state.status = 'loading';
  //     })
  //     .addCase(fetchBookByBarcode.fulfilled, (state, action) => {
  //       state.status = 'succeeded';
  //       state.book = action.payload;
  //     })
  //     .addCase(fetchBookByBarcode.rejected, (state, action) => {
  //       state.status = 'failed';
  //       state.error = action.payload;
  //     });
  // },
});

export const { setBookOffer, clearBookOffer } = bookSlice.actions;

export default bookSlice.reducer;
